import React, { useEffect, useState } from 'react'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import './CartButton.scss';
import { CartItem } from '../../types/types';
import { removeCartItem } from '../../redux/reducers/cartReducer';
import Button from '../Button/Button';
import { useNavigate } from 'react-router-dom';

const CartButton = () => {
  const dispatch = useAppDispatch()
  const cart = useAppSelector((state) => state.cartReducer)
  const [itemsToDisplay,setItems] = useState<CartItem[]>([])
  const navigation = useNavigate()
  useEffect(() => {
    if(cart.length > 4) setItems(cart.slice(0, 4))
    else setItems(cart)
    
  }, [cart]);
  const removeItem = (item: CartItem) => {
    dispatch(removeCartItem(item.id))
  }
  return (
    <div className='cartButton'>
        <button>
            {cart.length > 0 && <span className="size"><span>{cart.length}</span></span>}
            <ShoppingCartOutlinedIcon sx={{fill: "#fff"}}/>
        </button>
        <div className="cartButton-inner">
          <div className="cartButton-inner-wrapper">
            <div className="cartButton-inner-header">
              <span className="cartButton-inner-header__title">My cart</span>
              <span className="cartButton-inner-header__amount">{cart.length} item in cart</span>
              <Button variant='outlined' action={() => navigation('/cart')}>View or Edit Your Cart</Button>
            </div>
            <div className="cartButton-inner-list">
              {itemsToDisplay.map(item => {
                return (
                  <div key={item.id} className='cartButton-item'>
                    <div className="count">{item.count}</div>
                    <div className="product">
                      <div className="image">
                        <img src={item.product.images[0]} alt="" />
                      </div>
                      <div className="title">
                        <p>{item.product.title}</p>
                      </div>
                    </div>
                    <div className="options">
                      <div className="remove">
                        <Button action={() => removeItem(item)} variant='hollow' frontIcon={<CancelOutlinedIcon sx={{width: 20, height: 20}}/>}></Button>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            {cart.length > 0 && 
              (
                <div className='cartButton-inner-checkout'>
                  <p className="total">Subtotal: <span>${cart.reduce((a,b) => a + (b.product.price * b.count), 0)}</span></p>
                  <Button variant='filled' action={()=> navigation('/cart/checkout')}>Go To Checkout</Button>
                </div> 
              )
            }
          </div>
        </div>
    </div>
  )
}

export default CartButton